var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('headers')],1),_c('el-main',[_vm._t("default")],2),_c('footers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }